import state from './moduleChatFlowState'
import actions from './moduleChatFlowActions'
import getters from './moduleChatFlowGetters'
import mutations from './moduleChatFlowMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}
